import React from 'react';
import StudentTestInstructionsMain from './StudentTestInstructionsMain';

const StudentTestInstructions = () => {

    return (
        <div className="student-dashboard-page">
            <StudentTestInstructionsMain />
        </div>
    );
};

export default StudentTestInstructions;

